<template>
    <chart
        type="pie"
        :chart-data="chartData"
        :tooltips="tooltips"
        :display-legend="displayLegend"
        :animate="animate"
        :config="config"
        :options="options"
        :datasets="datasets"
    />
</template>

<script>
import Chart from 'src/components/charts/Chart';

export default {
    props: {
        tooltips: {
            type: Boolean,
            default: true,
        },
        displayLegend: {
            type: Boolean,
            default: true,
        },
        chartData: {
            type: Array,
            default: () => [],
        },
        centerText: {
            type: String,
        },
        cutoutPercentage: {
            type: Number,
            default: 0,
        },
        animate: {
            type: Boolean,
            deafult: null,
        },
    },
    components: {
        Chart,
    },
    computed: {
        config() {
            return {
                plugins: [
                    {
                        beforeDraw: chart => {
                            if (!this.centerText) {
                                return;
                            }

                            const printing =
                                chart.options.plugins.mode === 'print';

                            const width = chart.chart.width;
                            const height = chart.chart.height;
                            const ctx = chart.chart.ctx;

                            ctx.restore();
                            const fontSize = (height / 95).toFixed(2);
                            ctx.font = fontSize + 'em sans-serif';
                            ctx.textBaseline = 'middle';
                            ctx.fillStyle = printing ? 'black' : 'white';

                            const text = this.centerText;
                            const textX = Math.round(
                                (width - ctx.measureText(text).width) / 2,
                            );
                            const textY = height / 2;

                            ctx.fillText(text, textX, textY);
                            ctx.save();
                        },
                    },
                ],
            };
        },
        options() {
            return {
                cutoutPercentage: this.cutoutPercentage,
            };
        },
        datasets() {
            const backgroundColor = this.chartData.map(item => item.background);

            return [
                {
                    data: this.chartData.map(item => item.value),
                    backgroundColor,
                    hoverBackgroundColor: backgroundColor,
                    borderWidth: backgroundColor.map(color => 0),
                },
            ];
        },
    },
};
</script>

